module.exports = __webpack_public_path__ + "img/02.56bf6cc4.png";